var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CookieBar',{attrs:{"is-visible":!_vm.isCookieConsent}}),_c('notifications',{attrs:{"group":"updated-profile","position":"bottom left"}}),_c('base-layout',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:this.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }